/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchSmallList = {
    type: 'array',
    contains: {
        type: 'MatchSmall',
    },
} as const;
